import Alpine from "alpinejs"
import collapse from "@alpinejs/collapse"
import Cookies from "js-cookie"

Window.Cookies = Cookies

Alpine.plugin(collapse)
window.Alpine = Alpine
Alpine.start()

require("./bootstrap")
require("./core-polyfill")
require("./body-scroll-status")
require("./scroll-to")
require("./accordion")
require("./splide.js")
require("@clockwork-marketing-dev/front-mobile-navigation")
require("../sections/sitemap.js")
require("./gallery")
require("./lazyframe")

requireOptionalFiles()

function requireOptionalFiles() {
  const requireCustomFile = require.context("./optionals", true, /\.js$/, "lazy")
  requireCustomFile.keys().forEach((filePath) => {
    requireCustomFile(filePath)
  })
}
